const vehiculos = {
    "Hyundai": {
      "Alto Riesgo": ["Verna"],
      "Mediano Riesgo": ["Accent", "Elantra", "i10"],
      "Bajo Riesgo 1": ["Otro"],
      "Bajo Riesgo 2": ["Tucson", "Santa Fe", "Creta"]
    },
    "Kia": {
      "Alto Riesgo": ["Soluto"],
      "Mediano Riesgo": ["Río", "Cerato", "Picanto", "Sonet"],
      "Bajo Riesgo 1": ["Otro"],
      "Bajo Riesgo 2": ["Sportage", "Sorento"]
    },
    "Mazda": {
      "Alto Riesgo": ["Mazda 3"],
      "Mediano Riesgo": ["CX3", "Mazda 2", "CX9", "CX30"],
      "Bajo Riesgo 1": ["Otro"],
      "Bajo Riesgo 2": ["CX5"]
    },
    "Nissan": {
      "Alto Riesgo": ["Sentra"],
      "Mediano Riesgo": ["Versa", "Tiida"],
      "Bajo Riesgo 1": ["Otro"],
      "Bajo Riesgo 2": ["Xtrail"]
    },
    "Tucson": {
      "Bajo Riesgo 1": ["Otro"]
    },
    "Subaru": {
      "Alto Riesgo": ["Impreza"],
      "Mediano Riesgo": ["XV"],
      "Bajo Riesgo 1": ["Otro"]
    },
    "Suzuki": {
      "Alto Riesgo": ["Swift", "Ciaz"],
      "Mediano Riesgo": ["Vitara", "Nomade", "Ertiga", "SX4", "Celerio", "Dzire", "Alto", "S-presso", "XL7"],
      "Bajo Riesgo 1": ["Otro"],
    },
    "Toyota": {
      "Alto Riesgo": ["Corolla", "Yaris", "Etios"],
      "Mediano Riesgo": ["Rush", "Agya"],
      "Bajo Riesgo 1": ["Otro"],
      "Bajo Riesgo 2": ["RAV4", "Land Cruiser Prado", "Land Cruiser"]
    },
    "Chevrolet": {
      "Mediano Riesgo": ["Otro"]
    },
    "Mercedes": {
      "Bajo Riesgo 1": ["Otro"]
    },
    "BMW": {
      "Bajo Riesgo 1": ["Otro"]
    },
    "Audi": {
      "Bajo Riesgo 1": ["Otro"]
    },
    "Ford": {
      "Mediano Riesgo": ["Fiesta"],
      "Bajo Riesgo 1": ["Otro"],
      "Bajo Riesgo 2": ["Ecosport"]
    },
    "Honda": {
      "Mediano Riesgo": ["HRV", "WRV"],
      "Bajo Riesgo 1": ["Otro"],
      "Bajo Riesgo 2": ["CRV"]
    },
    "Mitsubishi": {
      "Mediano Riesgo": ["Outlander", "Xpander", "Lancer"],
      "Bajo Riesgo 1": ["Otro"],
    },
    "Peugeot": {
      "Mediano Riesgo": ["207", "306", "307"],
      "Bajo Riesgo 1": ["Otro"],
    },
    "Seat": {
      "Mediano Riesgo": ["León", "Ibiza", "Cordova", "Altea"],
      "Bajo Riesgo 1": ["Otro"],
    },
    "Volkswagen": {
      "Mediano Riesgo": ["Gol"],
      "Bajo Riesgo 1": ["Otro"],
      "Bajo Riesgo 2": ["Tiguan"]
    },
    "Otro": {
      "Mediano Riesgo": ["Otro"],
    }
  }
export default vehiculos